var ScrollReveal = require('scrollreveal');


var sr           = ScrollReveal({
    easing: 'ease-in-out',
    scale:  1,
});


module.exports = sr;